import React, {Component} from 'react';
import PropTypes from 'prop-types';
import GoogleMap from 'google-map-react';
import {isEqual} from 'lodash';
import {Observable} from 'rxjs';
import {Marker} from '../marker/marker';
import {Place} from "app/model/place";
import {MapPosition} from "app/model/mapPosition";

export class Map extends Component {
    static get propTypes() {
        return {
            apiKey: PropTypes.string.isRequired,
            points: PropTypes.arrayOf(PropTypes.instanceOf(Place)).isRequired,
            position: PropTypes.instanceOf(MapPosition).isRequired,
            pointCenteredZoom: PropTypes.number.isRequired,
            handleMarkerClick$: PropTypes.instanceOf(Observable).isRequired,
            handleMapPositionChange$: PropTypes.instanceOf(Observable).isRequired,
        };
    }

    constructor(props) {
        super(props);

        this.state = {
            position: this.props.position,
        };

        this.handleChildClick = this.handleChildClick.bind(this);
        this.handleBoundsChange = this.handleBoundsChange.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        if (isEqual(props.position, state.position)) {
            return null;
        }

        return {
            position: props.position
        };
    }

    handleChildClick(key, childProps) {
        this.props.handleMapPositionChange$.next(new MapPosition(
            this.props.pointCenteredZoom,
            {
                lat: Number(childProps.lat),
                lng: Number(childProps.lng),
            }
        ));
    }

    handleBoundsChange({center, zoom}) {
        this.props.handleMapPositionChange$.next(new MapPosition(zoom, center));
    }

    render() {
        return (
            <div className="map-container">
                <GoogleMap
                    bootstrapURLKeys={{
                        key: this.props.apiKey,
                        libraries: []
                    }}
                    onChange={this.handleBoundsChange}
                    onChildClick={this.handleChildClick}
                    center={this.state.position.position}
                    zoom={this.state.position.zoom}
                    yesIWantToUseGoogleMapApiInternals>
                    {this.props.points.map((point, k) => (
                        <Marker
                            lat={point.lat}
                            lng={point.lng}
                            point={point}
                            onClick$={this.props.handleMarkerClick$}
                            key={k}>
                            {k + 1}
                        </Marker>
                    ))}
                </GoogleMap>
            </div>
        );
    }
}
